export default {"src":"/_next/static/media/freeDelivery.154e8797.svg","height":21,"width":21};